export default (axios, config) => ({
  // Где вызывается: сервер.
  async getAll(type) {
    const { data } = await axios.get(
      `${config.SERVICE_DATABASE_API_URL}/params/getAll`,
      { params: { type } },
    );
    return data;
  },
  // Где вызывается: сервер.
  async get(type, code) {
    const { data } = await axios.get(
      `${config.SERVICE_DATABASE_API_URL}/params`,
      { params: { type, code } },
    );
    return data;
  },
});
